import React, { FC } from 'react';
import styled from 'styled-components';
import GenericBoothPreview from './GenericBoothPreview';

const BoothContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export interface BoothTierGroupProps {
  exhibitorIdsWithIndex: {
    id: string;
    index: number;
  }[]
}

const BoothTierGroup: FC<BoothTierGroupProps> = ({ exhibitorIdsWithIndex }) => (
  <BoothContainer>
    {exhibitorIdsWithIndex.map(({ id, index }) => (
      <GenericBoothPreview key={id} boothId={id} index={index} enableTier />
    ))}
  </BoothContainer>
);

export default BoothTierGroup;
